// Spanish strings. Same keys as the en/pt blocks in ./index.js; missing keys fall back to English.
const es = {
  'wel.eyebrow': "Bienvenido a My Football Game",
  'wel.title': "¡Tu equipo está listo!",
  'wel.squadReady': "Hemos creado un equipo inicial con una plantilla completa: ya está en tu Plantilla, listo para jugar.",
  'wel.squad': "Plantilla: gestiona tu once, suplentes y reservas.",
  'wel.tactics': "Táctica: elige tu formación y estilo de juego.",
  'wel.challenge': "Desafíos: juega contra otros equipos y sube en la liga.",
  'wel.shop': "Tienda: abre sobres de jugadores con oro.",
  'wel.seeSquad': "Ver mi plantilla",
  'wel.explore': "Explorar primero",
  'nav.dashboard': "Inicio",
  'nav.squad': "Plantilla",
  'sq.swapped': "{in} entra en el once; {out} pasa al banquillo.",
  'sq.xiFull': "El once está completo: asciende a alguien y lo cambiamos automáticamente, o saca a un titular.",
  'sq.injuredBlock': "Jugador lesionado: solo puede quedarse en las reservas.",
  'sq.injuredBlockN': "Jugador lesionado ({n} partidos): solo puede quedarse en las reservas.",
  'sq.sell': "Vender",
  'sq.modifyListing': "Cambiar precio",
  'sq.quickSell': "Venta rápida",
  'sq.quickSellHint': "Vende ahora por el 60% del valor de mercado.",
  'sq.sellHint': "Sácalo del once/banquillo para venderlo.",
  'sq.soldFor': "{name} vendido por €{coins}.",
  'sq.sold': "Jugador vendido.",
  'sq.sellErr': "No se pudo vender.",
  'nav.training': "Entrenamiento",
  'nav.tactics': "Táctica",
  'nav.transfers': "Fichajes",
  'nav.league': "Liga",
  'nav.leaderboard': "Clasificación",
  'nav.challenges': "Desafíos",
  'nav.friends': "Amigos",
  'nav.matches': "Partidos",
  'nav.shop': "Tienda",
  'nav.settings': "Ajustes",
  'nav.menu': "Menú",
  'set.section': "Cuenta · Ajustes",
  'set.title': "AJUSTES",
  'set.subtitle': "Gestiona tu cuenta, los datos del club y tus preferencias.",
  'set.profile': "Perfil",
  'set.email': "Email",
  'set.coachName': "Nombre del entrenador",
  'set.clubName': "Nombre del club",
  'set.save': "Guardar",
  'set.saved': "¡Guardado!",
  'set.coachNameNote': "Cambiar el nombre del entrenador necesita un endpoint del servidor.",
  'set.preferences': "Preferencias",
  'tour.dashboard': "Inicio: tu despacho, con presupuesto, ranking y próximo partido.",
  'tour.squad': "Plantilla: gestiona tu once, suplentes y reservas; vende jugadores.",
  'tour.tactics': "Táctica: elige tu formación y estilo de juego.",
  'tour.league': "Liga: juega desafíos y sube en la tabla.",
  'tour.menu': "Menú: tienda, ligas privadas, amigos y ajustes.",
  'tour.next': "Siguiente",
  'tour.done': "¡Vamos!",
  'notif.promptTitle': "¿Activar notificaciones?",
  'notif.promptBody': "Recibe avisos cuando te desafíen, con resultados de partidos y ventas de jugadores.",
  'notif.promptYes': "Activar notificaciones",
  'notif.promptNo': "Ahora no",
  'set.renameToken': "Renombrar",
  'set.coachTokenNote': "Requiere un “Token de cambio de nombre” (en la Tienda, 100 de oro).",
  'set.coachRenamed': "¡Entrenador renombrado!",
  'set.needCoachToken': "Necesitas un Token de cambio de nombre. Cómpralo en la Tienda.",
  'set.notifications': "Notificaciones",
  'set.notifPush': "Notificaciones del dispositivo",
  'set.notifOn': "Activadas: recibes avisos de desafíos, resultados y ventas.",
  'set.notifOff': "Desactivadas. Actívalas para recibir avisos.",
  'set.notifBlocked': "Bloqueadas en el navegador. Actívalas en los ajustes del sitio.",
  'set.notifActive': "Activas",
  'set.notifEnable': "Activar",
  'set.notifRecent': "Recientes",
  'set.notifMarkAll': "Marcar todo como leído",
  'set.notifEmpty': "Sin notificaciones.",
  'set.language': "Idioma",
  'set.account': "Cuenta",
  'set.logout': "Cerrar sesión",
  'set.logoutHint': "Cierra la sesión de tu cuenta en este dispositivo.",
  'set.changePassword': "Cambiar contraseña",
  'set.changePasswordHint': "Te enviamos un enlace para restablecerla a tu email.",
  'set.passwordEmailSent': "¡Email de restablecimiento enviado!",
  'set.deleteAccount': "Eliminar cuenta",
  'set.deleteHint': "Elimina la cuenta y todos los datos de forma permanente. Irreversible.",
  'set.deleteConfirmTitle': "¿Eliminar cuenta?",
  'set.deleteConfirmBody': "Es permanente y borra tu equipo, jugadores e historial. Confírmalo con tu contraseña.",
  'set.passwordPlaceholder': "Tu contraseña",
  'set.deleteBtn': "Eliminar para siempre",
  'set.cancel': "Cancelar",
  'set.errGeneric': "Algo salió mal. Inténtalo de nuevo.",
  'set.emailInUse': "Ese email ya está en uso.",
  'nav.home': "Inicio",
  'nav.section': "Navegación",
  'share.result': "Compartir resultado",
  'share.won': "Le gané {score} al {opp} ⚽ ¿Crees que lo harías mejor?",
  'share.drew': "Empaté {score} con el {opp} ⚽ ¿Crees que lo harías mejor?",
  'share.lost': "Perdí {score} con el {opp}... ¿crees que lo harías mejor? ⚽",
  'share.winPrompt': "¡Ganaste {score}! Reta a un amigo a hacerlo mejor contra tu club.",
  'share.challenge': "Retar a un amigo",
  'share.share': "Compartir",
  'share.via': "Compartir por",
  'share.copyLink': "Copiar enlace",
  'share.copied': "¡Copiado!",
  'cl.email': "Email",
  'cl.password': "Contraseña (mín. 6)",
  'cl.coachName': "Nombre del entrenador (opcional)",
  'cl.save': "Guardar mi club",
  'cl.saveGoogle': "Guardar con Google",
  'cl.orEmail': "o con email",
  'cl.claimError': "No se pudo guardar tu club.",
  'cl.notFound': "Este desafío no existe o ha caducado.",
  'cl.playError': "No se pudo empezar el partido.",
  'cl.discover': "Descubre el juego",
  'cl.challengedBy': "¡{coach} te desafía!",
  'cl.record': "{w}V {d}E {l}D",
  'cl.plays': "{n} desafíos aceptados",
  'cl.pitch': "Consigue una plantilla en un segundo y juega contra este club ahora mismo.",
  'cl.yourTeam': "Nombre de tu equipo (opcional)",
  'cl.playNow': "Aceptar el desafío",
  'cl.playWithMyClub': "Jugar con mi club",
  'cl.noSignup': "Gratis, sin registro, se juega en tu navegador.",
  'cl.keepTitle': "Guarda tu club",
  'cl.keepBody': "Conserva tu equipo, hazte amigo de {coach} y juega tu propia temporada.",
  'cl.keepBodyGame': "Estás jugando como invitado. Guarda tu club para no perder tu equipo ni tus resultados.",
  'cl.continueGuest': "Seguir como invitado",
  'cl.goToGame': "Ir al juego",
  'cl.rematch': "Revancha",
  'cl.guestBanner': "Estás jugando como invitado. Guarda tu club para no perderlo.",
  'inv.title': "Reta a tus amigos con un enlace",
  'inv.body': "Abren el enlace y juegan contra tu club al instante, sin registro.",
  'inv.share': "Compartir",
  'inv.copy': "Copiar",
  'inv.copied': "¡Copiado!",
  'inv.error': "No se pudo crear el enlace.",
  'inv.message': "A que no le ganas al {team} ⚽ Juega ya, sin registro:",
  'inv.passOnTitle': "Ahora te toca retar a ti",
  'inv.passOnBody': "Ya tienes tu propio club. Envía el enlace a un amigo y mira si te gana.",
  'h2h.title': "Cara a cara",
  'h2h.wdl': "V-E-D",
  'h2h.played': "{n} jugados",
  'h2h.goals': "Goles {gf}-{ga}",
  'h2h.recent': "Partidos recientes",
  'h2h.never': "Todavía no has jugado contra {name}. ¡Hora de arreglarlo!",
  'h2h.revenge': "¡Toma la revancha!",
  'h2h.challenge': "Desafiar a {name}",
  'h2h.short': "Contra ti:",
  'h2h.noneYet': "Aún no hay partidos entre vosotros",
  'h2h.loadError': "No se pudo cargar el cara a cara.",
  'h2h.r.W': "V",
  'h2h.r.D': "E",
  'h2h.r.L': "D",
  'rk.title': "Liga clasificatoria",
  'rk.subtitle': "Desafía a otros entrenadores, gana puntos y sube de división.",
  'rk.you': "TÚ",
  'rk.played': "{n} jugados",
  'rk.of': "de {n}",
  'rk.toPromotion': "{n} pts para llegar a {league}",
  'rk.topLeague': "Estás en la máxima división. ¡Defiende tu sitio!",
  'rk.jumpToMe': "Ir a mi posición",
  'rk.club': "Club",
  'rk.p': "PJ",
  'rk.wdl': "V-E-D",
  'rk.pts': "Pts",
  'rk.empty': "Todavía no hay equipos en esta división.",
  'rk.loadError': "No se pudo cargar la clasificación.",
  'rk.range': "{from}–{to} de {total}",
  'rk.howItWorks': "Las victorias valen hasta 4 pts, los empates 1 y las derrotas restan 1. Alcanza el objetivo de la división para ascender.",
  'nav.season': "Temporada",
  'se.loadError': "No se pudo cargar tu temporada.",
  'se.playError': "No se pudo empezar el partido.",
  'se.retry': "Reintentar",
  'se.seasonN': "Temporada {n}",
  'se.seasonOver': "Temporada terminada",
  'se.matchdayOf': "Jornada {n}/{total}",
  'se.openTactics': "Abrir Táctica",
  'se.derby': "Derbi",
  'se.friend': "Amigo",
  'se.obj.top_eight': "Termina {pos} o mejor",
  'se.boardReaction': "Reacción de la directiva",
  'se.continue': "Continuar",
  'se.result.win': "Victoria",
  'se.result.draw': "Empate",
  'se.result.loss': "Derrota",
  'se.nextVs': "J{md} · {where} vs {opp}",
  'se.tone.thrashing': "¡Qué actuación! Así se hace, míster.",
  'se.tone.statement_win': "Una victoria de autoridad contra el {opp}. Has demostrado de lo que somos capaces.",
  'se.tone.expected_win': "El resultado que esperábamos. Sigue así.",
  'se.tone.good_draw': "Un punto útil contra el {opp}. Lo aceptamos.",
  'se.tone.poor_draw': "¿Un empate con el {opp}? Esperábamos más.",
  'se.tone.tough_loss': "Una derrota contra un rival fuerte. Lo entendemos, pero no puede convertirse en costumbre.",
  'se.tone.bad_loss': "Perder contra el {opp} es inaceptable.",
  'se.tone.humiliation': "Una humillación. La afición merece algo mejor.",
  'se.autoFilled': "Las lesiones o sanciones dejaron huecos en tu once. Tu asistente eligió: {names}.",
  'se.nextMatch': "Próximo partido",
  'se.home': "Local",
  'se.away': "Visitante",
  'se.watchMatch': "Ver el partido en curso",
  'se.playMatchday': "Jugar la jornada {n}",
  'se.rewards': "Victoria +{win} · Empate +{draw} monedas",
  'se.finalStanding': "Posición final",
  'se.outcome.champion': "¡Campeones!",
  'se.outcome.promoted': "¡Ascendidos!",
  'se.outcome.relegated': "Descendidos",
  'se.outcome.stayed': "Salvados",
  'se.nextDivision': "Próxima temporada: {name}",
  'se.prizeWon': "Premio de la temporada: +{coins} monedas",
  'se.prizeNone': "Sin premio esta temporada.",
  'se.startSeason': "Empezar la temporada {n}",
  'se.board': "Directiva",
  'se.mood.delighted': "Encantada",
  'se.mood.pleased': "Satisfecha",
  'se.mood.neutral': "Neutral",
  'se.mood.concerned': "Preocupada",
  'se.mood.furious': "Furiosa",
  'se.expectation': "La directiva espera:",
  'se.obj.title': "Ganar la liga",
  'se.obj.promotion': "Ascenso (top {n})",
  'se.obj.top_three': "Terminar entre los 3 primeros",
  'se.obj.top_half': "Mitad superior ({pos} o mejor)",
  'se.obj.survival': "Evitar el descenso ({pos} o mejor)",
  'se.onTrack': "en camino",
  'se.offTrack': "por debajo del objetivo",
  'se.confidence': "Confianza de la directiva",
  'se.ultimatumActive': "ULTIMÁTUM: gana {wins} de tus próximos {matches} partidos o perderás el premio de esta temporada.",
  'se.prizeForfeited': "No cumpliste el ultimátum: el premio de esta temporada queda cancelado.",
  'se.ev.season_start': "Nueva temporada. Contamos contigo: {target}.",
  'se.ev.warning': "Estos resultados no son suficientes. Esperamos una reacción.",
  'se.ev.praise': "Trabajo excelente, míster. La directiva está encantada.",
  'se.ev.ultimatum': "Se nos ha acabado la paciencia. Gana {wins} de los próximos {matches}.",
  'se.ev.ultimatum_passed': "Respondiste bajo presión. La directiva vuelve a respaldarte.",
  'se.ev.ultimatum_failed': "No cumpliste el ultimátum. No habrá premio esta temporada.",
  'se.ev.verdict_met': "Objetivo cumplido, terminando {pos}. ¡Enhorabuena!",
  'se.ev.verdict_missed': "Terminaste {pos}. Por debajo de lo esperado.",
  'se.promotion': "Ascenso",
  'se.relegation': "Descenso",
  'se.club': "Club",
  'se.p': "PJ",
  'se.w': "G",
  'se.d': "E",
  'se.l': "P",
  'se.gd': "DG",
  'se.pts': "Pts",
  'se.form': "Forma",
  'se.yourFixtures': "Tus partidos",
  'se.md': "J",
  'se.lastResults': "Última jornada",
  'se.noResults': "Aún no hay resultados. ¡Juega tu primera jornada!",
  'nav.club': "Club",
  'nav.play': "Jugar",
  'nav.compete': "Competir",
  'nav.me': "Perfil",
  'nav.overview': "Resumen",
  'nav.feed': "Comunidad",
  'nav.quickMatch': "Partido rápido",
  'nav.tournaments': "Torneos",
  'nav.career': "Carrera",
  'nav.missions': "Misiones",
  'nav.trophies': "Trofeos",
  'tour.play': "Jugar: el botón principal. Juega tu temporada, un partido rápido, reta a amigos o entra en torneos.",
  'tour.club': "Club: plantilla, táctica, entrenamiento y fichajes.",
  'tour.compete': "Competir: tabla de la liga, rankings y ligas privadas.",
  'tour.me': "Perfil: carrera, misiones, trofeos, tienda y ajustes.",
  'common.save': "Guardar",
  'common.saving': "Guardando...",
  'common.cancel': "Cancelar",
  'common.close': "Cerrar",
  'common.refresh': "Actualizar",
  'common.clear': "Limpiar",
  'common.loading': "Cargando...",
  'common.retry': "Reintentar",
  'common.all': "Todos",
  'common.edit': "Editar",
  'common.unknown': "Desconocido",
  'header.teamRank': "Ranking del equipo",
  'header.coachRank': "Ranking del entrenador",
  'header.budget': "Presupuesto",
  'header.points': "pts",
  'header.level': "Nivel",
  'header.online': "En línea",
  'header.offline': "Desconectado",
  'header.language': "Idioma",
  'dash.office': "Despacho del míster",
  'dash.challenge': "Desafiar",
  'dash.tactics': "Táctica",
  'dash.invite': "Invitar",
  'dash.lastMatch': "Último partido",
  'dash.recap': "Resumen",
  'dash.victory': "VICTORIA",
  'dash.defeat': "DERROTA",
  'dash.draw': "EMPATE",
  'dash.noMatch': "SIN PARTIDO",
  'dash.noRecentMatches': "Sin partidos recientes",
  'dash.startJourney': "¡Desafía a un rival y demuestra lo que vales!",
  'dash.playNow': "Jugar ahora",
  'dash.starPerformer': "Jugador destacado",
  'dash.noStandout': "Aún no hay destacado",
  'dash.squadStatus': "Estado de la plantilla",
  'dash.squad': "PLANTILLA",
  'dash.fit': "En forma",
  'dash.injured': "Lesionados",
  'dash.suspended': "Sancionados",
  'dash.allClear': "Todo en orden · ningún jugador no disponible",
  'dash.offline': "Desconectado",
  'dash.challengeHint': "Lanza un desafío",
  'dash.challengeHintOff': "Ponte En línea en la cabecera para desafiar",
  'dash.scouting': "Analizando al rival...",
  'dash.tacticalSetup': "Configuración táctica · En directo",
  'dash.style': "ESTILO",
  'dash.formation': "Formación",
  'dash.mentality': "Mentalidad",
  'dash.pressing': "Presión",
  'dash.line': "Línea",
  'dash.tempo': "Ritmo",
  'ch.arena': "Desafíos · Arena",
  'ch.title': "DESAFÍOS",
  'ch.league': "Liga",
  'ch.points': "Puntos",
  'ch.promotion': "ascenso",
  'ch.today': "Desafíos hoy",
  'ch.remaining': "restantes",
  'ch.buyExtra': "Comprar desafío extra",
  'ch.boughtExtra': "¡Desafío extra añadido!",
  'ch.status': "Estado",
  'ch.acceptsChallenges': "acepta desafíos",
  'ch.closed': "cerrado",
  'ch.challenge': "Desafiar",
  'ch.quickMatch': "Partido rápido",
  'ch.randomChallenge': "Desafío aleatorio",
  'ch.searching': "Buscando…",
  'ch.mustBeOnline': "Ponte En línea antes de desafiar.",
  'ch.dailyLimit': "Límite diario de desafíos alcanzado (3/día).",
  'ch.challengeStartError': "Desafío enviado, pero no se pudo abrir el partido. Revisa Partidos en directo / historial.",
  'ch.toggleError': "No se pudo cambiar el estado. Inténtalo de nuevo.",
  'ch.onlineNote': "Tienes que estar En línea para desafiar y que te desafíen. Toca la tarjeta Estado para cambiarlo.",
  'ch.tapToToggle': "Toca para cambiar",
  'at.title': "EQUIPOS DISPONIBLES",
  'at.subtitle': "Rivales disponibles",
  'at.search': "Buscar por equipo o entrenador...",
  'at.online': "En línea",
  'at.coach': "Entrenador",
  'at.noOpponents': "No hay rivales disponibles",
  'at.comeBack': "Vuelve más tarde para encontrar rivales",
  'at.clearSearch': "Borrar búsqueda",
  'mh.archive': "Archivo de partidos · Sector 05",
  'mh.title': "HISTORIAL",
  'mh.games': "Partidos",
  'mh.total': "total",
  'mh.wins': "Victorias",
  'mh.draws': "Empates",
  'mh.losses': "Derrotas",
  'mh.wShort': "V",
  'mh.dShort': "E",
  'mh.lShort': "D",
  'mh.winRate': "% de victorias",
  'mh.empty': "No hay partidos en el historial",
  'mh.emptyHint': "Tus partidos aparecerán aquí después de tu primer desafío.",
  'mh.seeMore': "Ver más ({count})",
  'mh.seeLess': "Ver menos",
  'mh.final': "Final",
  'mh.scheduled': "Programado",
  'mh.home': "Local",
  'mh.away': "Visitante",
  'sq.section': "Gestión de plantilla · Sector 03",
  'sq.title': "PLANTILLA",
  'sq.size': "Tamaño",
  'sq.avgOvr': "Media",
  'sq.value': "Valor",
  'sq.xi': "Once elegido",
  'sq.startingXi': "Once inicial",
  'sq.substitutes': "Suplentes",
  'sq.reserves': "Reservas",
  'sq.search': "Buscar en la plantilla...",
  'sq.saveLineup': "Guardar alineación",
  'sq.noStarters': "No hay jugadores en el once inicial",
  'sq.noSubs': "No hay suplentes elegidos",
  'sq.noPlayers': "No se encontraron jugadores",
  'sq.scouting': "Buscando jugadores...",
  'sq.xiInvalid': "Once incorrecto",
  'sq.xiTooMany': "Tienes {n} jugadores en el once (límite: 11). Pulsa para corregirlo.",
  'sq.xiTooFew': "Solo {n}/11 jugadores en el once. Asciende reservas para completarlo.",
  'sq.autofix': "Corregir automáticamente",
  'sq.pos': "Pos",
  'sq.player': "Jugador",
  'sq.age': "Edad",
  'sq.actions': "Acciones",
  'sq.segXi': "Once",
  'sq.bench': "Banquillo",
  'sq.toXi': "→ Once",
  'sq.toBench': "→ Banq.",
  'sq.toRes': "→ Res",
  'sq.moveTo': "Mover a",
  'sq.moveAria': "Mover a {name} a: {dest}",
  'sq.actionsFor': "Acciones de {name}",
  'sq.ageShort': "{n}A",
  'sq.inj': "Lesión",
  'sq.injN': "Lesión {n}",
  'sq.sus': "Sanc",
  'sq.listedChip': "En venta",
  'sq.attrs': "Atributos",
  'sq.aAtk': "ATA",
  'sq.aPas': "PAS",
  'sq.aSpd': "VEL",
  'sq.aDef': "DEF",
  'sq.aSta': "RES",
  'sq.aGk': "POR",
  'sq.fAll': "Todos",
  'sq.fGK': "POR",
  'sq.fDEF': "DEF",
  'sq.fMID': "MED",
  'sq.fATT': "DEL",
  'sq.filterPos': "Filtrar por posición",
  'sq.sort': "Ordenar",
  'sq.sortAsc': "Ascendente",
  'sq.sortDesc': "Descendente",
  'sq.clear': "Borrar",
  'sq.noMatch': "Ningún jugador coincide con «{q}»",
  'sq.emptyXi': "Elige 11 jugadores del banquillo o de las reservas.",
  'sq.emptyRes': "Todos están en la convocatoria.",
  'sq.showBench': "Ver banquillo",
  'sq.saving': "Guardando…",
  'sq.saved': "Guardado",
  'sq.saveFailed': "Error al guardar",
  'sq.savedOk': "Cambio guardado.",
  'sq.saveErr': "No se pudo guardar.",
  'sq.loadErr': "No se pudo cargar la plantilla.",
  'sq.notFound': "Jugador no encontrado.",
  'sq.movedSubsN': "Jugador movido al banquillo. El once tiene ahora {n} jugadores.",
  'sq.movedPromoted': "Jugador movido y un reserva ascendido.",
  'sq.noReserves': "No hay reservas para ascender. Asciende un reserva antes de sacar a este jugador del once.",
  'sq.gkInXi': "Ya tienes un portero en el once. Pásalo antes al banquillo.",
  'sq.xiExact': "El once debe tener exactamente 11 jugadores.",
  'sq.lineupSaved': "¡Alineación guardada!",
  'sq.fixedN': "{n} jugadores movidos al banquillo.",
  'sq.fixErr': "No se pudo corregir el once.",
  'sq.listedOk': "Jugador puesto en el mercado.",
  'sq.listErr': "No se pudo poner al jugador en venta.",
  'sq.askPrice': "Fija el precio de venta de {name}.",
  'sq.price': "Precio (€)",
  'sq.marketValue': "valor de mercado {v}",
  'sq.confirmSale': "Confirmar venta",
  'sq.listing': "Publicando…",
  'sq.confirmQuick': "Confirmar · +{v}",
  'tr.section': "Centro de entrenamiento · Sector 04",
  'tr.title': "ENTRENAMIENTO",
  'tr.attribute': "Atributo",
  'tr.player': "Jugador",
  'tr.cost': "Coste",
  'tr.balance': "Saldo",
  'tr.coins': "monedas",
  'tr.available': "disponibles",
  'tr.chooseAttr': "Atributo a entrenar",
  'tr.costByPos': "Coste por posición",
  'tr.attrCost': "Atributos y coste de entrenamiento",
  'tr.costHint': "Cada sesión da +1 al atributo. Coste = valor actual × 1000 monedas.",
  'tr.gainInfo': "+1 por sesión · máx. 99",
  'tr.selectToSeeCosts': "Elige un jugador para ver atributos y costes.",
  'tr.maxed': "Al máximo",
  'tr.processing': "Procesando...",
  'tr.trainResult': "¡Entrenado! {stat}: {from} → {to}",
  'tr.maxedStat': "Este atributo ya está al máximo (99).",
  'tr.insufficientCoins': "No tienes monedas suficientes para esta sesión.",
  'tr.selectPlayerFirst': "Elige un jugador para entrenar.",
  'tr.trainError': "Hubo un error al entrenar al jugador.",
  'tr.playerSelected': "¡{name} seleccionado!",
  'tr.selectionRemoved': "Selección eliminada.",
  'tr.coinsLoadError': "No se pudieron cargar las monedas del equipo.",
  'tr.playersLoadError': "No se pudieron cargar los jugadores de la plantilla.",
  'tr.trainPlayer': "Entrenar jugador",
  'tr.selectPlayer': "Elegir jugador",
  'tr.selectHint': "Elige un jugador de tu plantilla para entrenar",
  'tr.clickSelect': "Pulsa para elegir",
  'tr.noSquadPlayers': "No hay jugadores disponibles en la plantilla",
  'tr.clickToChoose': "Pulsa para elegir de la plantilla",
  'tr.scheduled': "Jugador elegido",
  'tr.train': "Entrenar",
  'tr.cancel': "Cancelar",
  'tr.trainedTitle': "Entrenamiento completado",
  'tr.trainedSub': "+1 punto en este atributo",
  'tr.overall': "Valoración (media)",
  'tr.continue': "Continuar",
  'tr.premium': "Contenido premium",
  'tr.advancedMethods': "MÉTODOS AVANZADOS",
  'tr.advancedDesc': "Desbloquea programas de entrenamiento especializados y acelera el desarrollo de la plantilla.",
  'tr.unlock': "Desbloquear",
  'tr.includes': "Entrenamiento táctico, físico y técnico",
  'tf.hub': "Centro de fichajes",
  'tf.manage': "Gestiona los traspasos de tus jugadores y las finanzas de la plantilla.",
  'tf.budget': "Presupuesto de fichajes",
  'tf.market': "Mercado de fichajes",
  'tf.shortlist': "Lista de seguimiento",
  'tf.selling': "En venta",
  'tf.history': "Historial",
  'tf.searchName': "Buscar jugador por nombre...",
  'tf.allPositions': "Todas las posiciones",
  'tf.priceValue': "Precio / Valor",
  'tf.noMarket': "No hay jugadores en el mercado con esos criterios.",
  'tf.emptyShortlist': "Tu lista de seguimiento está vacía.",
  'tf.noSelling': "No hay jugadores en venta",
  'tf.noSellingHint': "Pon jugadores en el mercado desde la plantilla o sus detalles.",
  'tf.forSale': "En venta",
  'tf.stop': "Retirar",
  'tf.stopSelling': "Retirar de la venta",
  'tf.buys': "Compras",
  'tf.sells': "Ventas",
  'tf.noHistory': "No hay {type} en el historial",
  'tf.noTransfers': "Aún no has hecho traspasos.",
  'tf.sign': "Fichar",
  'tf.addShortlist': "Añadir a la lista",
  'tf.removeShortlist': "Quitar de la lista",
  'tf.signPlayer': "Fichar jugador",
  'tf.overall': "Valoración general",
  'tf.attributes': "Atributos del jugador",
  'tf.currentClub': "Club actual",
  'tf.transferFee': "Precio del traspaso",
  'tf.coach': "Entrenador",
  'tf.details': "Detalles",
  'tf.sell': "Vender",
  'tf.years': "años",
  'fr.network': "Red de amigos",
  'fr.addFriend': "Añadir amigo",
  'fr.friendEmail': "Email o usuario del entrenador",
  'fr.send': "Enviar solicitud",
  'fr.received': "Solicitudes recibidas",
  'fr.sent': "Solicitudes enviadas",
  'fr.myFriends': "Mis amigos",
  'fr.noPending': "No hay solicitudes pendientes.",
  'fr.noSent': "No hay solicitudes enviadas.",
  'fr.noFriends': "Todavía no has añadido amigos.",
  'fr.count': "Amigos",
  'fr.pendingCount': "Pendientes",
  'fr.accept': "Aceptar",
  'fr.reject': "Rechazar",
  'fr.challenge': "Desafiar",
  'fr.msgChallengeFail': "No se pudo desafiar (puede que no esté en tu liga).",
  'fr.cancel': "Cancelar",
  'fr.remove': "Eliminar",
  'fr.since': "Desde",
  'fr.available': "Disponibles para desafiar",
  'fr.noAvailable': "No hay amigos disponibles para desafiar.",
  'fr.loading': "Cargando datos...",
  'fr.privacy': "Privacidad y seguridad",
  'fr.msgInvalidEmail': "Introduce un email o usuario válido",
  'fr.msgSent': "¡Solicitud de amistad enviada!",
  'fr.msgSendFail': "No se pudo enviar la solicitud",
  'fr.msgNowFriend': "¡Ahora eres amigo de {name}!",
  'fr.msgAcceptFail': "No se pudo aceptar la solicitud",
  'fr.msgRejected': "Solicitud rechazada",
  'fr.msgRejectFail': "No se pudo rechazar la solicitud",
  'fr.msgCancelled': "Solicitud cancelada",
  'fr.msgCancelFail': "No se pudo cancelar la solicitud",
  'fr.msgRemoved': "{name} se ha eliminado de tu lista de amigos",
  'fr.msgRemoveFail': "No se pudo eliminar al amigo",
  'lg.competition': "Competición · Sector 02",
  'lg.title': "CLASIFICACIÓN",
  'lg.subtitle': "Sigue tu progreso y desafía a los mejores entrenadores",
  'lg.matchWeek': "Jornada",
  'lg.standings': "Clasificación · En directo",
  'lg.table': "TABLA",
  'lg.clickTeam': "Pulsa un equipo para ver detalles",
  'lg.globalStats': "Estadísticas globales",
  'lg.h2h': "Cara a cara",
  'lg.h2hHint': "tus partidos contra este equipo",
  'lg.last5': "Últimos 5 partidos",
  'lg.h2hMatches': "Partidos cara a cara",
  'lg.noMatches': "No hay partidos registrados",
  'lg.backendNote': "Las estadísticas globales de otros equipos necesitan soporte del servidor. Mostrando: cara a cara.",
  'lg.myPos': "Tu posición",
  'lg.of': "de",
  'nt.eyebrow': "Club · Avisos",
  'nt.title': "NOTIFICACIONES",
  'nt.inbox': "BANDEJA",
  'nt.unread': "Sin leer",
  'nt.all': "Todas",
  'nt.filterUnread': "Sin leer",
  'nt.markAll': "Marcar todas",
  'nt.empty': "Sin notificaciones",
  'nt.delete': "Eliminar",
  'feed.eyebrow': "Mundo · En directo",
  'feed.title': "ACTIVIDAD",
  'feed.all': "Todo",
  'feed.friends': "Amigos",
  'feed.empty': "Sin actividad reciente",
  'feed.movedTo': "pasó a",
  'feed.unlocked': "desbloqueó",
  'fr.ranking': "Ranking de amigos",
  'fr.you': "TÚ",
  'lb.title': "RANKINGS",
  'lb.eyebrow': "Rankings globales · Estadísticas",
  'lb.subtitle': "Los mejores del mundo: equipos, goleadores y defensas",
  'lb.tabLeague': "Liga",
  'lb.tabTeams': "Equipos",
  'lb.tabGoals': "Goleadores",
  'lb.tabAssists': "Asistencias",
  'lb.tabDefense': "Defensa",
  'lb.tabRating': "Valoración",
  'lb.team': "Equipo",
  'lb.player': "Jugador",
  'lb.played': "PJ",
  'lb.wins': "G",
  'lb.draws': "E",
  'lb.losses': "P",
  'lb.points': "Pts",
  'lb.goalsFor': "GF",
  'lb.goalsAgainst': "GC",
  'lb.goalDiff': "DG",
  'lb.cleanSheets': "PI",
  'lb.goals': "Goles",
  'lb.assists': "Asistencias",
  'lb.perMatch': "por partido",
  'lb.rating': "Valoración",
  'lb.tackles': "Entradas",
  'lb.interceptions': "Intercep.",
  'lb.clearances': "Despejes",
  'lb.saves': "Paradas",
  'lb.defScore': "Punt. def.",
  'lb.all': "Todos",
  'lb.defenders': "Defensas",
  'lb.goalkeepers': "Porteros",
  'lb.empty': "Aún no hay datos. ¡Juega más partidos!",
  'lb.loadFail': "No se pudieron cargar los datos",
  'lb.page': "Página",
  'lb.prev': "Anterior",
  'lb.next': "Siguiente",
  'tc.section': "Táctica · Sector 06",
  'tc.title': "TÁCTICA",
  'tc.visualize': "Visualizar",
  'tc.presets': "Ajustes rápidos · Estilo de juego",
  'tc.presetsHint': "Configura todos los parámetros con un clic. Después ajusta y guarda.",
  'tc.current': "Actual",
  'tc.dirty': "Cambios sin guardar.",
  'tc.dirtyHint': "No olvides pulsar Guardar para aplicarlos.",
  'tc.saveNow': "Guardar ahora",
  'tc.need11Banner': "Elige a los 11 titulares para guardar tu equipo (faltan {n}).",
  'tc.unsavedTitle': "Cambios sin guardar",
  'tc.unsavedBody': "Tienes cambios tácticos sin guardar. ¿Guardar antes de salir?",
  'tc.unsavedSave': "Guardar y salir",
  'tc.unsavedDiscard': "Salir sin guardar",
  'tc.unsavedCancel': "Cancelar",
  'tc.mentality': "Mentalidad",
  'tc.avgRating': "Valoración media",
  'tc.status': "Estado",
  'tc.ready': "Listo ✓",
  'tc.missing': "Faltan {n}",
  'tc.card.general': "Filosofía general",
  'tc.card.attack': "Organización ofensiva",
  'tc.card.defense': "Estructura defensiva",
  'tc.card.setpieces': "Balón parado",
  'tc.card.takers': "Lanzadores designados",
  'tc.lab.mentality': "Mentalidad",
  'tc.lab.afterLoss': "Tras pérdida",
  'tc.lab.transition': "Transición",
  'tc.lab.buildup': "Salida de balón",
  'tc.lab.style': "Estilo de juego",
  'tc.lab.focus': "Zona de ataque",
  'tc.lab.width': "Amplitud",
  'tc.lab.tempo': "Ritmo",
  'tc.lab.passing': "Pases",
  'tc.lab.crossing': "Centros",
  'tc.lab.defLine': "Línea defensiva",
  'tc.lab.pressing': "Presión",
  'tc.lab.aggression': "Agresividad",
  'tc.lab.intensity': "Intensidad",
  'tc.lab.marking': "Tipo de marcaje",
  'tc.lab.corners': "Córners",
  'tc.lab.freekicks': "Tiros libres",
  'tc.lab.defFocus': "Foco defensivo",
  'tc.sp.offensive': "Ofensivo",
  'tc.sp.defensive': "Defensivo",
  'tc.tk.penalty': "Penaltis",
  'tc.tk.corner': "Córners",
  'tc.tk.shortFK': "Faltas cortas",
  'tc.tk.longFK': "Faltas lejanas",
  'tc.takersWarn': "Completa el once inicial para elegir a los lanzadores.",
  'tc.selectPlaceholder': "Elegir...",
  'tc.o.ment.defensiva': "Defensiva: prioriza la solidez",
  'tc.o.ment.cautelosa': "Cautelosa: equilibrio defensivo",
  'tc.o.ment.equilibrada': "Equilibrada: equilibrio perfecto",
  'tc.o.ment.positiva': "Positiva: busca el ataque",
  'tc.o.ment.ofensiva': "Ofensiva: presión total",
  'tc.o.loss.recuar': "Replegarse",
  'tc.o.loss.gegenpress': "Gegenpressing",
  'tc.o.trans.lenta': "Lenta",
  'tc.o.trans.rapida': "Rápida",
  'tc.o.build.curta': "Corta: salida desde atrás",
  'tc.o.build.longa': "Larga: juego directo",
  'tc.o.style.passes': "Juego de pases",
  'tc.o.style.contra-ataque': "Contraataque",
  'tc.o.style.organizado': "Ataque organizado",
  'tc.o.style.direto': "Juego directo",
  'tc.o.style.alas': "Por las bandas",
  'tc.o.style.tiki-taka': "Tiki-taka",
  'tc.o.focus.lado-esquerdo': "Banda izquierda",
  'tc.o.focus.zona-central': "Por el centro",
  'tc.o.focus.lado-direito': "Banda derecha",
  'tc.o.focus.misto': "Mixto: variar",
  'tc.o.width.estreita': "Estrecha",
  'tc.o.width.equilibrada': "Equilibrada",
  'tc.o.width.larga': "Amplia",
  'tc.o.tempo.baixo': "Bajo",
  'tc.o.tempo.normal': "Normal",
  'tc.o.tempo.alto': "Alto",
  'tc.o.pass.curtos': "Cortos",
  'tc.o.pass.misto': "Mixtos",
  'tc.o.pass.diretos': "Directos",
  'tc.o.cross.baixos': "Bajos",
  'tc.o.cross.misto': "Mixtos",
  'tc.o.cross.altos': "Altos",
  'tc.o.line.baixa': "Baja",
  'tc.o.line.media': "Media",
  'tc.o.line.alta': "Alta",
  'tc.o.press.baixo': "Baja",
  'tc.o.press.medio': "Media",
  'tc.o.press.alto': "Alta",
  'tc.o.aggr.baixa': "Baja",
  'tc.o.aggr.moderada': "Moderada",
  'tc.o.aggr.agressivo': "Agresiva",
  'tc.o.int.baixa': "Baja",
  'tc.o.int.normal': "Normal",
  'tc.o.int.alta': "Alta",
  'tc.o.mark.zona': "Zonal: por zonas",
  'tc.o.mark.homem': "Al hombre",
  'tc.o.corn.misto': "Mixtos",
  'tc.o.corn.primeiro-poste': "Primer palo",
  'tc.o.corn.segundo-poste': "Segundo palo",
  'tc.o.corn.curtos': "En corto",
  'tc.o.fk.direto': "Directo a portería",
  'tc.o.fk.cruzamento': "Centro",
  'tc.o.fk.curto': "En corto",
  'tc.o.dfoc.primeiro-poste': "Primer palo",
  'tc.o.dfoc.segundo-poste': "Segundo palo",
  'tc.o.dfoc.centro': "Centro",
  'tc.o.dfoc.misto': "Mixto",
  'tc.o.dcorn.misto': "Mixto",
  'tc.o.dcorn.zonal': "Zonal",
  'tc.o.dcorn.homem': "Al hombre",
  'tc.o.dfk.muralha': "Barrera",
  'tc.o.dfk.linha-alta': "Línea adelantada",
  'tc.o.dfk.zona': "Marcaje zonal",
  'tc.select': "Elegir",
  'tc.recommendedFirst': "Los jugadores recomendados aparecen primero",
  'tc.viewDetails': "Pulsa para ver detalles",
  'tc.recommended': "Recomendado",
  'tc.idealPos': "Posición ideal",
  'dc.eyebrow': "Bonus diario",
  'dc.toGo': "{n} más para +{coins} monedas",
  'dc.claimed': "¡Bonus reclamado!",
  'dc.claimedFull': "Bonus diario reclamado: +{coins} monedas 🎉",
  'tc.outOfPosWarn': "Fuera de posición: valoración reducida ~{pct}% en el motor.",
  'tc.outOfPosMajorTip': "Fuera de posición · −{pct}%",
  'tc.outOfPosMinorTip': "Posición específica · −{pct}%",
  'tc.outOfPos': "Fuera de posición",
  'tc.noPlayers': "No hay jugadores disponibles",
  'tc.lineup': "Alinear",
  'tc.playerDetail': "Detalle del jugador",
  'tc.close': "Cerrar",
  'tc.cancel': "Cancelar",
  'tc.tdesc.penalty': "Gran definición y sangre fría bajo presión",
  'tc.tdesc.corner': "Excelente centro y capacidad de pase",
  'tc.tdesc.freekick': "Buena técnica de disparo y pase preciso",
  'tc.stat.gk': "Portería",
  'tc.stat.def': "Defensa",
  'tc.stat.pas': "Pase",
  'tc.stat.att': "Ataque",
  'tc.stat.pac': "Velocidad",
  'tc.stat.sta': "Resistencia",
  'tc.pitchHint': "Pulsa una posición para alinear a un jugador",
  'tc.notif.gkPosOnly': "Solo un portero puede ocupar la posición de POR.",
  'tc.notif.gkPlayerOnly': "Un portero solo puede jugar en la posición de POR.",
  'tc.notif.moved': "Jugador movido a una nueva posición.",
  'tc.notif.cleared': "Alineación borrada.",
  'tc.notif.injuredCantPlay': "Jugador lesionado: no puede jugar y se queda en el banquillo hasta recuperarse.",
  'tc.notif.injuredMovedOut': "{n} jugador(es) lesionado(s) retirado(s) del once. Alinea un sustituto.",
  'tc.injuredTag': "Lesionado · {n}p",
  'tc.injuredShort': "Lesionado",
  'tc.injuredCantPlay': "Lesionado: no puede jugar",
  'tc.notif.need11': "Error: elige exactamente 11 titulares distintos.",
  'tc.notif.tacticsSavedNeed11': "Táctica guardada. La alineación necesita exactamente 11 titulares para guardarse.",
  'tc.notif.tacticsSavedNoGk': "Táctica guardada. El once necesita exactamente 1 portero para guardar la alineación.",
  'tc.notif.tacticsSavedManyGk': "Táctica guardada. El once tiene {n} porteros (máx. 1): corrígelo para guardar la alineación.",
  'tc.notif.saved': "¡Táctica y plantilla guardadas!",
  'tc.notif.saveErr': "Error al guardar la táctica.",
  'tc.notif.saveLineupErr': "Error al guardar la alineación.",
  'tc.viz.onPitch': "EN EL CAMPO",
  'tc.viz.attackUp': "Ataque hacia arriba ↑",
  'tc.viz.effect': "Efecto del parámetro",
  'tc.lab.attackFocus': "Foco de ataque",
  'tc.viz.fx.mentality': "Posición del bloque en el campo",
  'tc.viz.fx.defLine': "Altura de la última línea (trazos volt)",
  'tc.viz.fx.pressing': "Zona donde se recupera el balón (sombra volt)",
  'tc.viz.fx.width': "Distancia de los carriles al centro",
  'tc.viz.fx.focus': "Dónde se concentra el ataque (objetivo)",
  'tc.viz.fx.tempo': "Velocidad de circulación del balón",
  'tc.v.estreita': "Estrecha",
  'tc.v.equilibrada': "Equilibrada",
  'tc.v.larga': "Amplia",
  'tc.v.lado-esquerdo': "Izquierda",
  'tc.v.zona-central': "Centro",
  'tc.v.lado-direito': "Derecha",
  'tc.v.misto': "Mixto",
  'tc.f.4-4-2.name': "4-4-2 Clásico",
  'tc.f.4-4-2.desc': "Equilibrio clásico.",
  'tc.f.4-3-3.name': "4-3-3 Ataque",
  'tc.f.4-3-3.desc': "Presión y amplitud ofensiva.",
  'tc.f.4-2-3-1.name': "4-2-3-1 Control",
  'tc.f.4-2-3-1.desc': "Posesión y creatividad en ataque.",
  'tc.f.3-5-2.name': "3-5-2 Dinámico",
  'tc.f.3-5-2.desc': "Dominio del centro del campo con carrileros adelantados.",
  'tc.f.5-3-2.name': "5-3-2 Bloque",
  'tc.f.5-3-2.desc': "Bloque bajo con laterales cerca de la defensa.",
  'tc.f.5-4-1.name': "5-4-1 Muro",
  'tc.f.5-4-1.desc': "Solidez defensiva, transiciones rápidas.",
  'tc.f.4-1-4-1.name': "4-1-4-1 Compacto",
  'tc.f.4-1-4-1.desc': "Solidez defensiva y transición.",
  'tc.f.4-3-1-2.name': "4-3-1-2 Rombo",
  'tc.f.4-3-1-2.desc': "Juego interior concentrado.",
  'tc.f.4-4-1-1.name': "4-4-1-1 Apoyo",
  'tc.f.4-4-1-1.desc': "Seguridad con apoyo detrás del delantero.",
  'tc.f.3-4-3.name': "3-4-3 Presión",
  'tc.f.3-4-3.desc': "Amplitud y presión constante por las bandas.",
  'tc.f.4-2-4.name': "4-2-4 Impacto",
  'tc.f.4-2-4.desc': "Máxima presencia ofensiva y amplitud.",
  'tc.f.3-4-1-2.name': "3-4-1-2 Creativo",
  'tc.f.3-4-1-2.desc': "Mediapunta que alimenta a dos delanteros, con carrileros abiertos.",
  'tc.f.4-5-1.name': "4-5-1 Densidad",
  'tc.f.4-5-1.desc': "Compacidad y paciencia en ataque.",
  'tc.f.4-3-2-1.name': "4-3-2-1 Árbol",
  'tc.f.4-3-2-1.desc': "Centro del campo controlado con dos mediapuntas.",
  'tc.f.4-2-2-2.name': "4-2-2-2 Parejas",
  'tc.f.4-2-2-2.desc': "Dos pivotes y dos creadores detrás de dos delanteros.",
  'tc.f.5-2-3.name': "5-2-3 Transiciones",
  'tc.f.5-2-3.desc': "Solidez atrás con tres arriba.",
  'tc.f.3-2-4-1.name': "3-2-4-1 Fluidez",
  'tc.f.3-2-4-1.desc': "Dos mediocentros defensivos y cuatro por delante.",
  'tc.f.3-5-1-1.name': "3-5-1-1 Equilibrio",
  'tc.f.3-5-1-1.desc': "Creatividad central en apoyo del delantero.",
  'tc.presetApplied': "Estilo '{name}' aplicado. Recuerda guardar.",
  'tc.preset.park-the-bus.label': "Aparcar el autobús",
  'tc.preset.park-the-bus.desc': "Defensa extrema: bloque bajo, contraataque",
  'tc.preset.counter-attack.label': "Contraataque",
  'tc.preset.counter-attack.desc': "Cauteloso: esperar y salir a toda velocidad",
  'tc.preset.balanced.label': "Equilibrado",
  'tc.preset.balanced.desc': "Configuración por defecto: adaptable",
  'tc.preset.tiki-taka.label': "Tiki-Taka",
  'tc.preset.tiki-taka.desc': "Posesión: pase corto, presión posicional",
  'tc.preset.gegenpress.label': "Presión alta",
  'tc.preset.gegenpress.desc': "Estilo Klopp: recuperar el balón arriba con intensidad",
  'tc.v.defensiva': "Defensiva",
  'tc.v.cautelosa': "Cautelosa",
  'tc.v.positiva': "Positiva",
  'tc.v.ofensiva': "Ofensiva",
  'tc.v.baixo': "Bajo",
  'tc.v.médio': "Medio",
  'tc.v.alto': "Alto",
  'tc.v.baixa': "Baja",
  'tc.v.média': "Media",
  'tc.v.alta': "Alta",
  'tc.v.normal': "Normal",
  'ps.career': "Carrera",
  'ps.matches': "Partidos",
  'ps.goals': "Goles",
  'ps.assists': "Asistencias",
  'ps.rating': "Valoración",
  'ps.age': "Edad",
  'ps.country': "País",
  'ps.height': "Altura",
  'ps.weight': "Peso",
  'ps.minutes': "Minutos",
  'ps.yellow': "Amarillas",
  'ps.red': "Rojas",
  'ps.passAcc': "Precisión de pase",
  'ps.shotAcc': "Precisión de tiro",
  'ps.recentForm': "Forma reciente",
  'ps.noStats': "Estadísticas de carrera no disponibles para este jugador.",
  'game.loadingTitle': "Iniciando simulación...",
  'game.stepUser': "Cargar datos del usuario",
  'game.stepTeam': "Sincronizar el equipo",
  'game.stepPlayers': "Cargar la plantilla",
  'game.stepFinish': "Todo listo",
  'game.error': "No se pudo cargar el equipo",
  'shop.vault': "Inversión del club · Cámara",
  'shop.title': "TIENDA DEL CLUB",
  'shop.subtitle': "Invierte en el futuro de tu club.",
  'shop.buy': "Comprar",
  'shop.pack.small': "Capital semilla",
  'shop.pack.medium': "Patrocinador local",
  'shop.pack.big': "Inyección de capital",
  'shop.pack.pro': "Inversor ángel",
  'shop.pack.elite': "Magnate del petróleo",
  'shop.pack.mega': "Dueño multimillonario",
  'shop.balance': "Saldo",
  'shop.coins': "Dinero",
  'shop.inSquadNote': "Los jugadores ya están en tu plantilla (reservas).",
  'shop.goToSquad': "Ir a la plantilla",
  'shop.gold': "Monedas de oro",
  'shop.goldPacks': "Comprar monedas de oro",
  'shop.goldPacksHint': "Se pagan con dinero real (Stripe). Usa el oro para desafíos extra y ligas privadas.",
  'shop.convert': "Convertir monedas → oro",
  'shop.convertHint': "Cambia dinero del club por oro (€{rate} = 1 de oro).",
  'shop.convertAmount': "Oro a recibir",
  'shop.convertCost': "Coste",
  'shop.convertBtn': "Convertir",
  'shop.extra': "Desafíos extra",
  'shop.extraHint': "Cada hueco extra cuesta {coins} monedas o {gold} de oro.",
  'shop.buyWithCoins': "Pagar con monedas",
  'shop.buyWithGold': "Pagar con oro",
  'shop.items': "Artículos",
  'shop.noItems': "No hay artículos disponibles ahora mismo.",
  'shop.buyReal': "Comprar",
  'shop.purchaseOk': "¡Compra completada!",
  'shop.purchaseErr': "No se pudo completar la compra.",
  'shop.insufficient': "Saldo insuficiente.",
  'shop.redirecting': "Redirigiendo al pago...",
  'shop.playerPacks': "Sobres de jugadores",
  'shop.playerPacksHint': "Abre un sobre y consigue jugadores aleatorios dentro del rango de media del sobre.",
  'shop.buyCoins': "Comprar dinero",
  'shop.buyCoinsHint': "Recarga el presupuesto de tu club con dinero real (Stripe).",
  'shop.packsUnavailable': "No disponible ahora mismo. (backend: GET /store/packs)",
  'shop.openPack': "Abrir sobre",
  'shop.tapToOpen': "Toca para abrir",
  'shop.revealNext': "Siguiente carta",
  'shop.packResult': "Nuevos jugadores",
  'shop.continue': "Continuar",
  'shop.opening': "Abriendo...",
  'shop.cardOne': "CARTA",
  'shop.cards': "CARTAS",
  'shop.packTier.bronze': "Sobre de bronce",
  'shop.packTier.silver': "Sobre de plata",
  'shop.packTier.gold': "Sobre de oro",
  'shop.packTier.diamond': "Sobre de diamante",
  'shop.packDesc': "Consigue {n} jugador(es) · Media {min}-{max}",
  'shop.extraName': "Desafío extra",
  'shop.extraDesc': "+1 hueco de desafío",
  'nav.leagues': "Ligas privadas",
  'pl.section': "Ligas privadas · Arena social",
  'pl.title': "LIGAS PRIVADAS",
  'pl.subtitle': "Crea o únete a ligas con tus amigos.",
  'pl.create': "Crear liga",
  'pl.createHint': "Crea una liga y comparte el código de invitación.",
  'pl.leagueName': "Nombre de la liga",
  'pl.createBtn': "Crear",
  'pl.join': "Unirse con código",
  'pl.joinHint': "¿Tienes un código de invitación? Únete aquí.",
  'pl.inviteCode': "Código de invitación",
  'pl.joinBtn': "Unirse",
  'pl.myLeagues': "Mis ligas",
  'pl.noLeagues': "Todavía no estás en ninguna liga privada.",
  'pl.noStandings': "Aún no hay partidos: comparte el código para que tus amigos se unan y empiecen a jugar.",
  'pl.stRecruiting': "Inscripciones abiertas",
  'pl.stActive': "Activa",
  'pl.stCompleted': "Terminada",
  'pl.stCancelled': "Cancelada",
  'pl.prize': "Premio",
  'pl.recruitEndsIn': "Las inscripciones terminan en",
  'pl.endsIn': "Termina en",
  'pl.dailyChallenges': "Hoy",
  'pl.challengeBtn': "Desafiar",
  'pl.you': "TÚ",
  'pl.winnerIs': "🏆 Campeón: {name}",
  'pl.recruitingHint': "Esperando miembros: necesitas 3 o más en 24 h; si no, la liga se cancela y se devuelve el oro.",
  'pl.noDailyLeft': "No te quedan desafíos de liga hoy. Vuelve mañana.",
  'pl.cantLeaveActive': "No puedes salir mientras la temporada está en curso.",
  'pl.duration': "Duración",
  'pl.durationLabel': "Duración de la temporada",
  'pl.daysShort': "d",
  'pl.maxMembers': "Máx. miembros",
  'pl.createFieldsHint': "Duración de la temporada y número máximo de jugadores que pueden unirse.",
  'pl.createPrizeNote': "Al final de la temporada, el 1.º gana un premio en oro + monedas.",
  'pl.copy': "Copiar código",
  'pl.share': "Compartir",
  'pl.shareText': "¡Únete a mi liga \"{name}\" en My Football Game! Código de invitación: {code}",
  'pl.shareCopied': "Código copiado: ¡compártelo con tus amigos!",
  'pl.champPrize': "Premio del campeón",
  'pl.matchHistory': "Historial de partidos",
  'pl.prizeWinnerOnly': "Solo lo recibe el 1.º al final de la temporada. Nadie más.",
  'lmv.matchCenter': "Centro del partido",
  'lmv.ft': "FIN",
  'lmv.htShort': "DESC",
  'lmv.fullTime': "Final del partido",
  'lmv.firstHalf': "Primera parte",
  'lmv.secondHalf': "Segunda parte",
  'lmv.kickoff': "Saque inicial",
  'lmv.momentum': "Dominio ofensivo",
  'lmv.assist': "Asistencia: {player}",
  'lmv.skip': "Ir al final",
  'lmv.continue': "Continuar",
  'lmv.potm': "Jugador del partido",
  'lmv.bench': "Suplentes",
  'lmv.noLineups': "Alineaciones no disponibles para este partido.",
  'lmv.ratingsAtFt': "Las valoraciones aparecen al final del partido.",
  'lmv.aPlayer': "un jugador",
  'lmv.tab.feed': "Narración",
  'lmv.tab.stats': "Estadísticas",
  'lmv.tab.lineups': "Alineaciones",
  'lmv.type.season': "Liga",
  'lmv.type.challenge': "Partido rápido",
  'lmv.type.tournament': "Torneo",
  'lmv.type.league_challenge': "Liga privada",
  'lmv.type.link_challenge': "Desafío por enlace",
  'lmv.st.shots': "Tiros",
  'lmv.st.possession': "Posesión",
  'lmv.st.xg': "Goles esperados (xG)",
  'lmv.st.on_target': "Tiros a puerta",
  'lmv.st.corners': "Córners",
  'lmv.st.free_kicks': "Tiros libres",
  'lmv.st.offsides': "Fueras de juego",
  'lmv.st.saves': "Paradas",
  'lmv.st.yellow': "Tarjetas amarillas",
  'lmv.st.red': "Tarjetas rojas",
  'lmv.pos.Goalkeeper': "POR",
  'lmv.pos.Defender': "DEF",
  'lmv.pos.Midfielder': "MED",
  'lmv.pos.Forward': "DEL",
  'lmv.c.goal.0': "¡GOOOL! ¡{player} marca para el {team}!",
  'lmv.c.goal.1': "¡{player} no perdona y marca para el {team}!",
  'lmv.c.goal.2': "¡Gol del {team}! Definición letal de {player}.",
  'lmv.c.own_goal.0': "¡Gol en propia puerta de {player}! Desgracia para el {team}.",
  'lmv.c.save.0': "¡Paradón de {player}! El {opp} estuvo cerca.",
  'lmv.c.save.1': "{player} vuela para negárselo al {opp}.",
  'lmv.c.save.2': "Disparo del {opp}, atrapado sin problemas por {player}.",
  'lmv.c.miss.0': "{player} dispara... ¡fuera!",
  'lmv.c.miss.1': "Ocasión para el {team}, pero {player} la manda por encima.",
  'lmv.c.miss.2': "{player} prueba suerte, desviado.",
  'lmv.c.block.0': "Disparo del {opp} bloqueado por {player}.",
  'lmv.c.block.1': "{player} se lanza para frenar al {opp}.",
  'lmv.c.offside.0': "{player} está en fuera de juego.",
  'lmv.c.offside.1': "Bandera arriba: {player} se adelantó.",
  'lmv.c.corner.0': "Córner para el {team}.",
  'lmv.c.corner.1': "El {team} saca un córner, pero lo despejan.",
  'lmv.c.free_kick.0': "Falta a favor del {team}, sin peligro.",
  'lmv.c.free_kick.1': "El {team} lanza la falta y la defensa resuelve.",
  'lmv.c.yellow_card.0': "Tarjeta amarilla para {player} ({team}).",
  'lmv.c.yellow_card.1': "El árbitro amonesta a {player}.",
  'lmv.c.red_card.0': "¡Tarjeta roja! {player} es expulsado y el {team} se queda con diez.",
  'lmv.c.injury.0': "{player} está lesionado y necesita asistencia.",
  'lmv.c.injury.1': "Preocupación en el {team}: {player} está en el suelo.",
  'lmv.c.substitution.0': "Cambio en el {team}: entra {in}, sale {out}.",
  'lmv.c.penalty_scored.0': "¡Penalti marcado por {player}!",
  'lmv.c.penalty_missed.0': "¡{player} falla el penalti!",
  'lmv.reconnect': "Reconectar",
  'lmv.halftime': "Descanso",
  'lmv.startingSoon': "El partido está a punto de empezar",
  'lmv.underway': "Partido en marcha: aún no hay incidencias",
  'lmv.leave': "Abandonar el partido",
  'lmv.forfeitTitle': "¿Abandonar el partido?",
  'lmv.forfeitBody': "Si sales ahora, contará como una",
  'lmv.forfeitLoss': "derrota 3-0",
  'lmv.forfeitConfirm': "Sí, abandonar",
  'lmv.forfeitCancel': "Seguir jugando",
  'mm.goal': "¡GOOOOOL!",
  'mm.ownGoal': "GOL EN PROPIA",
  'mm.save': "¡PARADA!",
  'mm.penalty': "¡PENALTI!",
  'mm.offside': "FUERA DE JUEGO",
  'mm.yellow': "TARJETA AMARILLA",
  'mm.red': "EXPULSADO",
  'mm.sub': "CAMBIO",
  'mm.miss': "¡FUERA!",
  'mm.block': "¡BLOQUEADO!",
  'mm.kickoff': "SAQUE INICIAL",
  'mm.fulltime': "FINAL",
  'mm.live': "EN DIRECTO",
  'mm.lastPlay': "Última jugada",
  'mm.noPlaysYet': "Balón en juego: aún no hay incidencias",
  'pl.members': "miembros",
  'pl.owner': "Creador",
  'pl.standings': "Clasificación",
  'pl.team': "Equipo",
  'pl.played': "PJ",
  'pl.win': "G",
  'pl.draw': "E",
  'pl.loss': "P",
  'pl.gd': "DG",
  'pl.points': "Pts",
  'pl.copyCode': "Copiar código",
  'pl.copied': "¡Copiado!",
  'pl.leave': "Salir de la liga",
  'pl.delete': "Eliminar liga",
  'pl.kick': "Expulsar",
  'pl.back': "Volver",
  'pl.createdOk': "¡Liga creada! Código: {code}",
  'pl.joinedOk': "¡Te has unido a la liga!",
  'pl.leftOk': "Has salido de la liga.",
  'pl.errGeneric': "Algo salió mal. Inténtalo de nuevo.",
  'pl.costNote': "Crear una liga cuesta {gold} monedas de oro.",
  'pl.noGold': "No tienes oro suficiente para crear la liga.",
  'reg.title': "NUEVO ENTRENADOR",
  'reg.subtitle': "Empieza aquí tu carrera como entrenador.",
  'reg.step1': "Credenciales",
  'reg.step2': "Datos del club",
  'reg.teamName': "Nombre del equipo",
  'reg.username': "Tu nombre (entrenador)",
  'reg.email': "Email",
  'reg.password': "Contraseña",
  'reg.confirmPass': "Confirmar contraseña",
  'reg.agree': "Acepto los",
  'reg.terms': "Términos y condiciones",
  'reg.back': "Volver",
  'reg.next': "Continuar →",
  'reg.create': "Fundar club",
  'reg.creating': "Procesando...",
  'reg.hasAccount': "¿Ya tienes cuenta?",
  'reg.login': "Inicia sesión aquí",
  'login.title': "BIENVENIDO DE NUEVO",
  'login.subtitle': "Accede a la gestión de tu club.",
  'login.email': "Email",
  'login.password': "Contraseña",
  'login.remember': "Recordarme",
  'login.submit': "ENTRAR",
  'login.loading': "Verificando credenciales...",
  'login.noAccount': "¿Todavía no eres entrenador?",
  'login.register': "Regístrate aquí",
  'reg.emailIsRequired': "El email es obligatorio",
  'reg.coachNameIsRequired': "El nombre del entrenador es obligatorio",
  'reg.teamNameIsRequired': "El nombre del equipo es obligatorio",
  'reg.invalidEmail': "Email no válido",
  'reg.passwordMustBeAt': "La contraseña debe tener al menos 6 caracteres",
  'reg.registrationFailedPleaseTry': "El registro falló. Inténtalo de nuevo.",
  'reg.play': "JUGAR",
  'reg.now': "YA",
  'reg.freeNoDownload30': "Gratis · Sin descargas · 30 segundos",
  'reg.100CoachesPlaying': "Más de 100 entrenadores jugando",
  'reg.signingIn': "Entrando...",
  'reg.signUpWithGoogle': "Registrarse con Google",
  'reg.1ClickTeamAuto': "1 clic · equipo generado automáticamente",
  'reg.orSignUpWith': "— o regístrate con email —",
  'reg.email2': "email",
  'reg.password2': "Contraseña",
  'reg.min6Characters': "Mínimo 6 caracteres",
  'reg.coachName': "Nombre del entrenador",
  'reg.eGAlexFerguson': "p. ej. Luis Aragonés",
  'reg.teamName2': "Nombre del equipo",
  'reg.eGThunderFc': "p. ej. Rayo FC",
  'reg.inviteCodeOptional': "Código de invitación (opcional)",
  'reg.invalidCode': "Código no válido",
  'reg.creating2': "Creando...",
  'reg.createTeam': "Crear equipo",
  'reg.bySigningUpYou': "Al registrarte, aceptas los",
  'login.signingIn': "Entrando...",
  'login.continueWithGoogle': "Continuar con Google",
  'login.orWithEmail': "o con email",
  'wel.yourFirstMatchIs': "¡Tu primer partido ya se está simulando!",
  'wel.yourTeamIsReady': "¡Tu equipo está listo y tu primer partido ya ha empezado! Mira el resultado en tu inicio.",
  'wel.goToDashboard': "Ir al inicio",
  'com.inviteFriends': "INVITA A AMIGOS",
  'com.earnRewards': "Gana recompensas",
  'com.youGet50kCoins': "Tú ganas 50K monedas + 5 de oro",
  'com.whenYourFriendPlays': "cuando tu amigo juega su primer partido.",
  'com.yourFriendGets25k': "Tu amigo recibe 25K monedas al registrarse.",
  'com.code': "CÓDIGO",
  'com.shareInvite': "Compartir invitación",
  'com.copied': "¡Copiado!",
  'com.invited': "Invitados",
  'com.active': "Activos",
  'com.earned': "Ganado",
  'com.referralSystemUnavailable': "Sistema de invitaciones no disponible.",
  'com.community': "COMUNIDAD",
  'com.joinUs': "Únete",
  'com.chatChallengesCommunityTips': "Chat, desafíos y consejos de la comunidad",
  'reg.features': "18 formaciones tácticas|Mercado de fichajes|Partidos en tiempo real|Ligas privadas",
  'reg.invitedBy': "✓ Invitado por {coach}: ¡recibirás 25K monedas de bonus!",
  'com.shareText': "¡Juega conmigo en My Football Game! Usa el código {code} y gana 25K monedas de bonus ⚽🪙",
  'av.noneFound': "No se encontraron equipos",
  'av.tryAnother': "Prueba otro nombre",
  'ts.saving': "Guardando...",
  'ts.serverTooBig': "El escudo es demasiado grande para el servidor. Prueba otra imagen o pega una URL.",
  'tour.knockout': "Eliminatorias",
  'go.gameOver': "Fin del juego",
  'go.finalStats': "Tus estadísticas finales",
  'go.seasons': "Temporadas como entrenador",
  'go.finalPosition': "Posición final",
  'go.shareTwitter': "Compartir en Twitter",
  'go.shareFacebook': "Compartir en Facebook",
  'go.shareReddit': "Compartir en Reddit",
  'go.shareWhatsapp': "Compartir por WhatsApp",
  'go.copyResult': "Copiar resultado",
  'go.betterLuck': "¡Más suerte con tu próximo club! ¿Listo para otro desafío?",
  'go.feedbackTitle': "¡Tu opinión importa!",
  'go.fbGeneral': "Opinión general",
  'go.fbGameplay': "Jugabilidad",
  'go.fbDifficulty': "Dificultad",
  'go.fbBugs': "Errores/Problemas",
  'go.fbSuggestions': "Sugerencias",
  'go.fbOther': "Otro",
  'go.fbPlaceholder': "¿Qué te gustó o no te gustó? ¿Alguna sugerencia?",
  'go.thanks': "¡Gracias!",
  'go.thanksBody': "Tu opinión se ha enviado. ¡Te lo agradecemos!",
  'rev.financial': "Impacto económico",
  'rev.reputation': "Cambio de reputación",
  'rev.percentage': "Variación porcentual",
  'rev.impact': "Impacto del evento",
  'rev.attention': "Este evento requiere tu atención. ¿Cómo quieres proceder?",
  'av.eyebrow': "Rivales disponibles",
  'av.title': "EQUIPOS DISPONIBLES",
  'av.search': "Buscar por equipo o entrenador...",
  'av.coach': "Entrenador",
  'av.challenging': "Desafiando...",
  'av.challenge': "Desafiar",
  'av.loadError': "No se pudieron cargar los equipos disponibles",
  'av.dailyLimit': "¡Límite diario de desafíos alcanzado! Puedes enviar 3 desafíos al día.",
  'av.noneAvailable': "No hay rivales disponibles",
  'av.comeBack': "Vuelve más tarde para encontrar rivales",
  'set.inviteFriends': "Invita a amigos",
  'set.inviteBody': "Comparte tu código: ganas 50K monedas + 5 de oro cuando tu amigo juega su primer partido. ¡Él recibe 25K monedas de bonus al registrarse!",
  'set.yourCode': "Tu código de invitación",
  'set.playing': "Jugando",
  'set.recentInvites': "Invitaciones recientes",
  'mr.timeline': "Cronología del partido",
  'mr.comparison': "Comparación de equipos",
  'mr.points': "Puntos ganados",
  'mr.fans': "Felicidad de la afición",
  'mr.revenue': "Ingresos del partido",
  'mr.scorers': "Tus goleadores",
  'cmr.injured': "¡Jugador lesionado!",
  'cmr.leaguePoints': "Puntos de liga",
  'cmr.coins': "Monedas",
  'ts.title': "Ajustes del club",
  'ts.teamName': "Nombre del equipo",
  'ts.clubName': "Nombre del club",
  'ts.pasteUrl': "…o pega la URL de una imagen",
  'ts.save': "Guardar",
  'ts.loadError': "No se pudo cargar tu equipo.",
  'ts.pickImage': "Elige un archivo de imagen.",
  'ts.tooBig': "Imagen demasiado grande (máx. 10MB).",
  'ts.readError': "No se pudo leer la imagen.",
  'ts.invalidImage': "Imagen no válida.",
  'ts.processError': "No se pudo procesar la imagen.",
  'ts.saveError': "No se pudo guardar.",
  'mh.eyebrow': "Entrenador",
  'mh.morale': "Moral",
  'mh.keepPlaying': "¡Sigue jugando para subir de nivel!",
  'mh.objectivesSoon': "Los objetivos de la temporada aparecerán pronto",
  'mh.overview': "Resumen",
  'mh.training': "Entrenamiento",
  'mh.objectives': "Objetivos",
  'tour.eyebrow': "Competitivo",
  'tour.teams': "Equipos",
  'tour.entryFee': "Inscripción",
  'tour.prizePool': "Bote de premios",
  'tour.format': "Formato",
  'tour.prizeDistribution': "Reparto de premios",
  'tour.bracket': "Cuadro",
  'mis.none': "Aún no hay misiones disponibles",
  'mis.weekly': "Semanal",
  'mis.allDone': "¡Todas las misiones completadas!",
  'sq.sellPlayer': "Vender jugador",
  'tac.player': "Jugador",
  'tac.attributes': "Atributos",
  'tac.preview': "Vista previa táctica",
  'tac.startersSet': "Titulares elegidos",
};

export default es;
